import React from 'react';
import moment from 'moment-timezone';
import { inject, observer } from 'mobx-react';
import { Box } from '@material-ui/core';
import { ThemeProvider } from 'styled-components';

import styles, { Container, Row, Col, Text, Name } from './styles';
import { colors } from '../../themes/colors';
import CorrectedValue from '../CorrectedValue';

const AxlDraftShipmentBox = (props) => {
  const { userStore, shipment, style, status, theme, onSelectShipment, jobStore } = props;
  const { blurCustomerInfo, blurCustomerAddress } = userStore;
  const { listCorrectedAddress } = jobStore;
  const correctedInfo = listCorrectedAddress?.find(d => d?.id === shipment.customer_profile_id)?.corrected_address || shipment?.dropoff_address;
  const originStreet = shipment?.dropoff_address?.street || '';
  const originAddressLine2 = `${shipment?.dropoff_address?.city}, ${shipment?.dropoff_address?.state} ${shipment?.dropoff_address?.zipcode}`;
  const correctedStreet = correctedInfo?.street || '';
  const correctedAddressLine2 = `${correctedInfo?.city}, ${correctedInfo?.state} ${correctedInfo?.zipcode}`;

  const selectShipment = (e) => {
    onSelectShipment && onSelectShipment();
  };

  const renderMainTheme = (shipment) => (
    <Box position={shipment?.duplicate_fields && 'relative'}>
      <Row>
        <Col>
          <div>
            <Name className={`${blurCustomerInfo ? 'text-blur' : ''}`}>{shipment && shipment.customer ? shipment.customer.name : '-'}</Name>
          </div>
          <div>
            <Text>{`${moment(shipment.dropoff_earliest_ts).format('HH:mm A')} - ${moment(shipment.dropoff_latest_ts).format('HH:mm A')}`}</Text>
          </div>
        </Col>
        <Col>
          <div>
            <Text className={`text-right`} style={blurCustomerAddress ? styles.textBlur : null}>
              <CorrectedValue originValue={originStreet} correctedValue={correctedStreet} blur={blurCustomerAddress} />
            </Text>
          </div>
          <div>
            <Text className={`text-right`}>
              <CorrectedValue originValue={originAddressLine2} correctedValue={correctedAddressLine2}/>
            </Text>
          </div>
        </Col>
      </Row>

      {shipment?.duplicate_fields && (
        <Box position={'absolute'} top={'20%'} left={'45%'} border={`1px solid ${colors.lightOrange}`} px={1} style={{ transform: 'rotate(-30deg)' }}>
          <span style={{ textTransform: 'uppercase', fontSize: 10, fontFamily: 'AvenirNext', color: colors.lightOrange }}>Duplicated</span>
        </Box>
      )}
    </Box>
  );

  const renderDefaulTheme = (shipment) => (
    <Row>
      <Col>
        <div>
          <Text className={blurCustomerInfo ? 'text-blur' : ''}>{shipment.internal_id}</Text>
        </div>
        <div>
          <Name>{shipment && shipment.customer ? shipment.customer.name : '-'}</Name>
        </div>
      </Col>
      <Col>
        <div>
          <Text className={`text-right`}>{shipment && shipment.dropoff_address ? shipment.dropoff_address.street : '-'}</Text>
        </div>
        <div>
          <Text className={`text-right`}>
            {shipment && shipment.dropoff_address ? shipment.dropoff_address.city + ', ' + shipment.dropoff_address.state + ' ' + shipment.dropoff_address.zipcode : ''}
          </Text>
        </div>
      </Col>
    </Row>
  );

  const customStyle = shipment?.duplicate_fields ? { borderColor: colors.lightOrange } : styles.statuses[status.replace(' ', '_')];

  return (
    <ThemeProvider theme={{ type: theme ?? 'default' }}>
      <Container onClick={selectShipment} style={{ ...style, ...customStyle }}>
        {theme && theme !== 'default' ? renderMainTheme(shipment) : renderDefaulTheme(shipment)}
      </Container>
    </ThemeProvider>
  );
};

export default inject('userStore', 'jobStore')(observer(AxlDraftShipmentBox));
